module.exports = __webpack_public_path__ + "85144e533054e09ca88acb6879c00f8a.svg";